import { useIsAuthorized, UserAction } from "src/permissions";

/**
 * Custom hook to check if user has Reviewer Permissions. This abstraction was created to be easily mock-able in unit
 * tests.
 */
export const useHasReviewerPermissions = (): boolean => {
    return useIsAuthorized(UserAction.viewReviewerOnlyFields);
};
